import { useEffect } from 'react';
import { devWarning } from '@tanium/coreui-utils';
import { useWorkbenchLocale } from '@tanium/react-locale-context';

export const generateUseInvalidUsageWarning = (packageName: string) => {
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
    return () => {};
  }

  const useInvalidUsageWarning = () => {
    const isValidUsage = !!useWorkbenchLocale();

    useEffect(() => {
      devWarning(
        isValidUsage,
        [
          `\`${packageName}\` was used outside of \`WorkbenchLocaleProvider\`.`,
          'The associated strings will not get translated; they will always be in English.',
          'Ensure all usages of `useTranslation` and `<Trans>`--including translated shared components--exist within the `WorkbenchLocaleProvider`.',
        ].join(' '),
      );
    }, [isValidUsage]);
  };

  return useInvalidUsageWarning;
};
